<form [formGroup]="channelsForm">
    <mat-form-field>
        <mat-select placeholder="{{'SELECT_CHANNELS_EXPE'|translate}}" formControlName="expeChannels" [disabled]="!editable"
                    (selectionChange)="setChannelsForm()" [value]="this.deviceParamLirisV3.inclinoAxes">
            <mat-option [value]="0">{{'CHANNEL_EXPE'|translate}} 1</mat-option>
            <mat-option [value]="1">{{'CHANNEL_EXPE'|translate}} 2</mat-option>
            <mat-option [value]="2">{{'CHANNEL_EXPE'|translate}} 1 &amp; 2</mat-option>
        </mat-select>
    </mat-form-field>
</form>

